import '@fontsource-variable/inter/wght.css';
import '@fontsource-variable/jetbrains-mono/wght.css';
import interLatinWoff2Url from '@fontsource-variable/inter/files/inter-latin-wght-normal.woff2?url';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.tsx';
import './App.css';

// Preload the primary UI font before React renders so the browser can fetch it
// in parallel with JS parsing — same technique as Eraser / the marketing site.
const interPreload = document.createElement('link');
interPreload.rel = 'preload';
interPreload.as = 'font';
interPreload.type = 'font/woff2';
interPreload.crossOrigin = 'anonymous';
interPreload.href = interLatinWoff2Url;
document.head.appendChild(interPreload);

const container = document.getElementById('root');
if (!container) {
    throw new Error('Root element #root not found');
}

createRoot(container).render(
    <StrictMode>
        <App />
    </StrictMode>,
);
